import { cn } from '@wwe-portal/ui/lib/lib';
import { cva } from 'class-variance-authority';
import { FC, ReactNode } from 'react';

const backgroundVariants = cva('', {
  variants: {
    direction: {
      up: 'rotate-180',
      down: '',
    },
    size: {
      sm: 'w-[44px] h-[22px]',
      md: '',
    },
  },
  defaultVariants: {
    direction: 'down',
    size: 'md',
  },
});

const containerVariants = cva(
  'absolute inset-x-0 top-0 flex items-center justify-center leading-none',
  {
    variants: {
      direction: {
        up: '-bottom-[25%]',
        down: 'bottom-[25%]',
      },
    },
    defaultVariants: {
      direction: 'down',
    },
  }
);

const textVariants = cva(
  'font-semibold text-white leading-none drop-shadow-fx',
  {
    variants: {
      size: {
        sm: 'text-xs',
        md: 'text-sm',
      },
    },
    defaultVariants: {
      size: 'sm',
    },
  }
);
const Background: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="33"
      viewBox="0 0 68 33"
      width="68"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.286 26.692L1.19 1.02l61.435.149 4.195 25.473H43.443l-8.024 5.75-8.752-5.757-20.381.057z"
        fill="#FFEC6C"
      />
      <path
        clipRule="evenodd"
        d="M.734.645l62.212.15 4.32 26.225h-23.7l-8.137 5.83-8.872-5.836-20.578.057L.734.645zm.917.754l4.945 24.918 20.185-.056 8.63 5.677 7.912-5.67H66.38L62.307 1.547 1.651 1.399z"
        fill="url(#paint0_linear_9616_4636)"
        fillRule="evenodd"
      />
      <path
        d="M6.033 23.393L1.743 1.44l60.529.132 3.534 21.512-59.773.308z"
        fill="url(#paint1_linear_9616_4636)"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_9616_4636"
          x1="31.669"
          x2="34.008"
          y1="1.022"
          y2="35.949"
        >
          <stop stopColor="#FD0" />
          <stop offset="0.47" stopColor="#FFA800" />
          <stop offset="0.745" stopColor="#FF144D" />
          <stop offset="1" stopColor="#FF7B00" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_9616_4636"
          x1="33.774"
          x2="33.774"
          y1="1.441"
          y2="23.393"
        >
          <stop offset="0.006" stopColor="#14AA3A" />
          <stop offset="0.54" stopColor="#0F641D" />
          <stop offset="0.932" stopColor="#0B5C18" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
      </defs>
    </svg>
  );
};

interface TalentBadgeProps {
  value: ReactNode;
  direction?: 'up' | 'down';
  size?: 'sm' | 'md';
}

export const TalentBadge: FC<TalentBadgeProps> = ({
  value,
  direction = 'down',
  size = 'md',
}) => {
  return (
    <div className="relative">
      <Background className={cn(backgroundVariants({ direction, size }))} />
      <div className={cn(containerVariants({ direction }))}>
        <span className={cn(textVariants({ size }))}>{value}</span>
      </div>
    </div>
  );
};
